import { useStytchOrganization } from "@stytch/react/b2b";
import { getCookie, setCookie } from "../util/cookie";
import { PrimeQueryKeys } from "../shared/constants";

// Chrome maxes out at 400 days.
const MAX_COOKIE_AGE_DAYS = 399;

/**
 * Get config for the specific key for the users organization.
 * @returns Value belonging to key, or undefined if it does not exist.
 */
export function useGetOrganizationConfigString(key: string): string | undefined {
    const { organization } = useStytchOrganization();
    return organization?.trusted_metadata?.[key] as string | undefined;
}

export function useCanGenerateSpreadsheet(): boolean {
    return useGetOrganizationConfigString("generateSpreadsheet") === "true";
}

export function useHasRichDocuments(): boolean {
    return useGetOrganizationConfigString("richDocuments") === "true";
}

export function useHasWorkflows(): boolean {
    return useGetOrganizationConfigString("workflows") === "true";
}

export function setShowDebugInfo(value: boolean) {
    setCookie(PrimeQueryKeys.showDebugInfoCookie, String(value), MAX_COOKIE_AGE_DAYS);
}

export function useShowDebugInfo(): boolean {
    return getCookie(PrimeQueryKeys.showDebugInfoCookie) === "true";
}

export function setShowEmbeddingText(value: boolean) {
    setCookie(PrimeQueryKeys.showEmbeddingTextCookie, String(value), MAX_COOKIE_AGE_DAYS);
}

export function useShowEmbeddingText(): boolean {
    return getCookie(PrimeQueryKeys.showEmbeddingTextCookie) === "true";
}

export function setHasNoConversations(value: boolean) {
    setCookie(PrimeQueryKeys.emptyConversationHistoryCookie, String(value), MAX_COOKIE_AGE_DAYS);
}

export function hasNoConversations(): boolean {
    return getCookie(PrimeQueryKeys.emptyConversationHistoryCookie) === "true";
}
